import { UserActionConst } from "../Constants/UserConstants";

const initialState = {
  loader: false,
  pendingUsers: [],
  pendingUsersError: null,
  allUsers: [],
  allUsersError: null,
  userDetail: null,
  userDetailError: null,
  approveSuccess: null,
  approveError: null,
  updateSuccess: null,
  updateError: null,
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case UserActionConst.FETCH_PENDING_USERS_REQUEST:
      return {
        ...state,
        loader: true,
        pendingUsersError: null,
      };

    case UserActionConst.FETCH_PENDING_USERS_SUCC:
      return {
        ...state,
        loader: false,
        pendingUsers: action.result.data || [],
        pendingUsersError: null,
      };

    case UserActionConst.FETCH_PENDING_USERS_FAIL:
      return {
        ...state,
        loader: false,
        pendingUsersError: action.result,
        pendingUsers: [],
      };

    case UserActionConst.FETCH_ALL_USERS_REQUEST:
      return {
        ...state,
        loader: true,
        allUsersError: null,
      };

    case UserActionConst.FETCH_ALL_USERS_SUCC:
      return {
        ...state,
        loader: false,
        allUsers: action.result.data || [],
        allUsersError: null,
      };

    case UserActionConst.FETCH_ALL_USERS_FAIL:
      return {
        ...state,
        loader: false,
        allUsersError: action.result,
        allUsers: [],
      };

    case UserActionConst.APPROVE_USER_REQUEST:
      return {
        ...state,
        loader: true,
        approveError: null,
        approveSuccess: null,
      };

    case UserActionConst.APPROVE_USER_SUCC:
      return {
        ...state,
        loader: false,
        approveSuccess: action.result,
        approveError: null,
        // Remove approved user from pending list
        pendingUsers: state.pendingUsers.filter(user => user.id !== action.userId),
      };

    case UserActionConst.APPROVE_USER_FAIL:
      return {
        ...state,
        loader: false,
        approveError: action.result,
        approveSuccess: null,
      };

    case UserActionConst.FETCH_USER_DETAIL_REQUEST:
      return {
        ...state,
        loader: true,
        userDetail: null, // clear stale detail so spinner shows immediately
        userDetailError: null,
        updateSuccess: null,
        updateError: null,
      };

    case UserActionConst.FETCH_USER_DETAIL_SUCC:
      return {
        ...state,
        loader: false,
        userDetail: action.result.data || action.result,
        userDetailError: null,
      };

    case UserActionConst.FETCH_USER_DETAIL_FAIL:
      return {
        ...state,
        loader: false,
        userDetailError: action.result,
        userDetail: null,
      };

    case UserActionConst.UPDATE_USER_REQUEST:
      return {
        ...state,
        loader: true,
        updateError: null,
        updateSuccess: null,
      };

    case UserActionConst.UPDATE_USER_SUCC:
      return {
        ...state,
        loader: false,
        updateSuccess: action.result,
        updateError: null,
        // Update the user in allUsers list if it exists
        allUsers: state.allUsers.map((user) =>
          user.id === action.userId
            ? { ...user, ...action.result.data }
            : user
        ),
      };

    case UserActionConst.UPDATE_USER_FAIL:
      return {
        ...state,
        loader: false,
        updateError: action.result,
        updateSuccess: null,
      };

    case UserActionConst.CLEAR_UPDATE_STATE:
      return {
        ...state,
        updateSuccess: null,
        updateError: null,
      };

    default:
      return state;
  }
};

export default userReducer;

